// src/Components/BankingReconciliation/components/RequisitionTable.jsx
import React from "react";
import Styles from "./RequisitionTable.module.css";
import RequisitionRow from "../RequisitionRow";
import { formatInr, signed } from "../../utils/reconFormat";

const RequisitionTable = ({ rows, onSelectRow }) => {
  const totals = rows.reduce(
    (a, r) => ({
      injected: a.injected + r.injected,
      drawable: a.drawable + r.drawable,
      drawn: a.drawn + (r.drawn || 0),
      remaining: a.remaining + r.remaining,
    }),
    { injected: 0, drawable: 0, drawn: 0, remaining: 0 }
  );

  return (
    <div className={`scroll_bar_x ${Styles.scroll}`}>
      <div className={Styles.table}>
        <div className={`${Styles.row} ${Styles.headRow}`}>
          <div className={Styles.colContract}>CONTRACT ID</div>
          <div className={Styles.colName}>REQUISITION</div>
          <div className={Styles.colBf}>BF</div>
          <div className={Styles.colNum}>INJECTED</div>
          <div className={Styles.colNum}>DRAWABLE</div>
          <div className={Styles.colNum}>DRAWN</div>
          <div className={Styles.colRemaining}>REMAINING</div>
          <div className={Styles.colStatus}>STATUS</div>
        </div>

        <div className={`scroll_bar_x ${Styles.body}`}>
          {rows.map((r) => (
            <RequisitionRow key={r.id} row={r} onSelect={onSelectRow} />
          ))}
        </div>

        <div className={`${Styles.row} ${Styles.totalRow}`}>
          <div className={Styles.colContract} />
          <div className={Styles.colName}>TOTALS · {rows.length} SHOWN</div>
          <div className={Styles.colBf} />
          <div className={Styles.colNum}>{formatInr(totals.injected)}</div>
          <div className={Styles.colNum}>{formatInr(totals.drawable)}</div>
          <div className={Styles.colNum}>{formatInr(totals.drawn)}</div>
          <div className={Styles.colRemaining}>{signed(totals.remaining)}</div>
          <div className={Styles.colStatus} />
        </div>
      </div>
    </div>
  );
};

export default RequisitionTable;
